import * as React from 'react';
import { SVGProps } from 'react';

const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.243 22 12 21.308l2.857-4.846h4.286c.379 0 .742-.146 1.01-.406s.418-.612.418-.98V6.77c0-.367-.15-.72-.418-.979a1.452 1.452 0 0 0-1.01-.405H4.857c-.379 0-.742.145-1.01.405s-.418.612-.418.98v8.307c0 .367.15.72.418.979.268.26.631.405 1.01.405h6.429v1.385H4.857a2.904 2.904 0 0 1-2.02-.81A2.727 2.727 0 0 1 2 15.075V6.77c0-.734.301-1.439.837-1.958A2.904 2.904 0 0 1 4.857 4h14.286c.758 0 1.484.292 2.02.811.536.52.837 1.224.837 1.958v8.308c0 .734-.301 1.439-.837 1.958a2.904 2.904 0 0 1-2.02.811h-3.457L13.243 22Z'
      fill='#000'
    />
    <path
      d='M17.714 8.154H6.286v1.384h11.428V8.154ZM13.428 12.308H6.286v1.384h7.143v-1.384Z'
      fill='#000'
    />
  </svg>
);

export default SvgChat;
